import { useRhythmicLogger } from '#imports'

import { getBoardsCollection } from '../getCollections'

const logger = useRhythmicLogger('useHarmonyPlanContext:deleteBoard')

function validateParams(boardId: string, context: { teamId: string; planId: string }) {
  if (!boardId) throw new Error('Board identifier is required to delete a harmony plan board')

  const { teamId, planId } = context

  if (!teamId) throw new Error('Team identifier is required to delete a harmony plan board')

  if (!planId) throw new Error('Harmony plan identifier is required to delete a board')

  return { boardId, teamId, planId }
}

export async function handleDeleteHarmonyPlanBoard(
  boardId: string,
  context: {
    teamId: string
    planId: string
  },
) {
  try {
    const { planId } = validateParams(boardId, context)
    const collection = getBoardsCollection(planId)
    const result = collection.delete(boardId)

    logger.info('Harmony plan board deleted', { planId, boardId })
    return result ?? null
  } catch (error) {
    logger.debug('Failed to delete harmony plan board', {
      boardId,
      context,
      error,
    })
    logger.error('deleteHarmonyPlanBoard failed', { error })
    if (error instanceof Error) throw error

    throw new Error('Failed to delete harmony plan board', { cause: error })
  }
}
